export default String.raw`
{% include 'partials/common/date-format.html' -%}	

{% if page.QueryString contains 'tab=erp-orders' -%}
	{% if customer.CompanyErpId <= 0 -%}
	<div class="no-data">{{ translations.AccessDenied }}</div>
	{% else %}
	<div class="eshop__table-container products erp-data-js" style="display: none" data-template="partials/customer-profile/orders/order-details.html">
		<table>
			<colgroup>
				<col style="width:120px">
				<col style="width:140px">
				<col style="width:400px">
				<col class="payment-status-js hidden-js" style="width:150px">
				<col style="width:150px">
			</colgroup>
			<div class="erp-orders-tab">
				<label for="dateTo">{{ translations.OrdFromLast3MonthsTo }}:</label>
				<input id="dateTo" class="form__input-value get-erp-data-js" type="date" name="dateTo" >
			</div>
			<thead>
				<tr>
					<th class="id">{{ translations.Number | Capitalize }}</th>
					<th>{{ translations.BuyDate }}</th>
					<th>{{ translations.OrdStatus }}</th>
					<th class="payment-status-js hidden-js">{{ translations.PaymentStatus }}</th>
					<th>{{ translations.Value }} {{ translations.Netto | Downcase }}</th>
					<th>{{ translations.Value }} {{ translations.Brutto | Downcase }}</th>
				</tr>
			</thead>
			<div class="table-js" data-sp="CDN.eShop_GetOrders">
				<tbody>
					<tr tabindex="0" class="row can-hover load-erp-order-details-js parent-container-reload-js" data-url="{{ page.Url }}?&deeper-lvl=true&erp-data=true&order-erp=true" rv-each-o="List">
						<td class="id hidden-js id-js">{ o.Id }</td>
						<td class="id">{ o.ERPOrderNumber }</td>
						<td>{ o.Date | date }</td>
						<td>
							<div class="state">
								<svg height="8" width="8" class="svgIcon" rv-fill="o.Status | statusColor">
									<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#circle-solid"></use>
								</svg>
								<div class="state__info">{ o.Status | status }</div>
							</div>
						</td>
						<td rv-if="o.StatusExists">
							<span rv-if="o.PaymentStatus0"><div class="danger-container">{{ translations.NotPaid }}</div></span>
							<span rv-if="o.PaymentStatus1"><div class="success-container">{{ translations.Paid }}</div></span>
							<span rv-if="o.PaymentStatus2"><div class="warning-container">{{ translations.PaidPartially }}</div></span>
							<span rv-if="o.DeliveryAndPaymentStatusExists">, </span>
							<span rv-if="o.DeliveryStatus0">{{ translations.ERPDeliveryStatus0 }}</span>
							<span rv-if="o.DeliveryStatus1">{{ translations.ERPDeliveryStatus1 }}</span>
							<span rv-if="o.DeliveryStatus2">{{ translations.ERPDeliveryStatus2 }}</span>
							<span rv-if="o.DeliveryStatus3">{{ translations.ERPDeliveryStatus3 }}</span>
							<span rv-if="o.DeliveryStatus4">{{ translations.ERPDeliveryStatus4 }}</span>
						</td>
						<td class="netto">{ o.SubtotalValue | price } { o.Currency }</td>
						<td class="brutto">{ o.TotalValue | price } { o.Currency }</td>
					</tr>
				</tbody>
			</div>
		</table>
		<div class="no-data">{{ translations.NoOrders }}</div>
		{% include 'partials/customer-profile/pagination.html' -%}
	</div>
	<div class="loader-js loader big"></div>
	{% endif -%}
	
{% else -%}
	{% if config.B2B == false %}
		{% if page.QueryString contains 'tab=executed-orders' -%}
			{% assign orders = customer-profile.OrdersExecuted -%}
			{% assign noOrders = translations.NoExecutedOrders -%}
			{% assign tab = 'executed-order-details' -%}
		{% else -%}
			{% assign orders = customer-profile.OrdersActive -%}
			{% assign noOrders = translations.NoActiveOrders -%}
			{% assign tab = 'active-order-details' -%}
		{% endif -%}
	{% else -%}
		{% assign orders = customer-profile.Orders -%}
		{% assign tab = 'order-details' -%}
	{% endif -%}

	{% assign orderString = customer-profile.OrderQueryGET -%}
	{% assign paginationPageNo = orders.PageNo -%}
	<div class="eshop__table-container">
		<table data-template="partials/customer-profile/orders/order-details.html">
			<colgroup>
				<col style="width:100px">
				<col style="width:140px">
				<col style="width:400px">
				<col style="width:150px">
				<col style="width:150px">
			</colgroup>
			<thead>
				<tr>
					<th class="id">{{ translations.Number | Capitalize }}</th>
					<th>{{ translations.BuyDate }}</th>
					<th>
						<div class="state {% if config.ENTERPRISE -%} ent {% endif -%}">{{ translations.OrdStatus }}</div>
					</th>
					<th class="payment {% if config.ENTERPRISE -%} ent {% endif -%}">{{ translations.PaymentStatus }}</th>
					{% if config.ENTERPRISE -%}
					<th>{{ translations.Value }} {{ translations.Netto }}</th>
					<th>{{ translations.Value }} {{ translations.Brutto }}</th>
					{% else -%}
					<th>{{ translations.Value }}</th>
					{% endif -%}
				</tr>
			</thead>
		{% if orders.TotalItems > 0 -%}
			<tbody>
				{% for order in orders.Orders -%}
					<tr tabindex="0" class="row can-hover load-deeper-lvl-js parent-container-reload-js open-order-details-js" data-id="{{ order.OrderId }}" data-url="{{ page.Url }}?{{ orderString | H }}={{ order.OrderId }}&deeper-lvl&tab={{tab}}">
						<td class="id">{{ order.OrderId }}</td>
						<td>{{ order.Date | Date:dateFormat }}</td>
						<td>
							<div class="state {% if config.ENTERPRISE -%} ent {% endif -%}">
								<svg height="8" width="8" class="svgIcon">
									{% if order.Status == 1 or order.Status == 5 -%}
									<use style="fill: {{settings.warningColor}}" href="css/img/fontawesome-icons.svg?v={{lqTS}}#circle-solid"></use>
									{% elseif order.Status == 3 -%}
									<use style="fill: {{settings.successColor}}" href="css/img/fontawesome-icons.svg?v={{lqTS}}#circle-solid"></use>
									{% elseif order.Status == 4 -%}
									<use style="fill: {{settings.errorColor}}" href="css/img/fontawesome-icons.svg?v={{lqTS}}#circle-solid"></use>
									{% else -%}
									<use style="fill: #0A68CA" href="css/img/fontawesome-icons.svg?v={{lqTS}}#circle-solid"></use>
									{% endif -%}
								</svg>
								<div>
									{{ order.StatusText }}
									{% if order.PaymentStatusText and order.DeliveryStatusText and order.DeliveryStatus != null and order.DeliveryStatus != -1 %}
										({{ order.DeliveryStatusText }})
									{% endif %}
								</div>
							</div>
						</td>
						<td class="payment {% if config.ENTERPRISE -%} ent {% endif -%}">
						{% if order.PaymentStatusText or order.DeliveryStatusText -%}
							{% if order.PaymentStatus == 1 -%}
							<div class="success-container">
								{% if order.PaymentStatusText -%}{{ order.PaymentStatusText }}{% endif -%}
							</div>
							{% elseif order.PaymentStatus == 0 -%}
							<div class="danger-container">
								{% if order.PaymentStatusText -%}{{ order.PaymentStatusText }}{% endif -%}
							</div>
							{% elseif order.PaymentStatus == 2 -%}
							<div class="warning-container">
								{% if order.PaymentStatusText -%}{{ order.PaymentStatusText }}{% endif -%}
							</div>
							{% endif -%}
						{% endif -%}
						</td>
						{% if config.ENTERPRISE -%}
							<td>{{ order.SubtotalValue | ToPrice }} {{ order.CurrencyExt }}</td>
							<td>{{ order.TotalValue | ToPrice }} {{ order.CurrencyExt }}</td>
						{% else -%}
							<td>{{ order.Value | ToPrice }} {{ order.CurrencyExt }}</td>
						{% endif -%}
					</tr>
				{% endfor -%}
			</tbody>
			{% endif -%}
		</table>
	</div>
	{% if orders.TotalItems > 0 -%}
	  	{% include 'partials/common/pagination.html' -%}
	{% else -%}
	<div class="no-data">{{ translations.NoOrders }}</div>
	{% endif -%}
{% endif -%}
`